import React, { useMemo } from "react";
import { parseNotificationMessage } from "../utils/notificationMessageParser";

export default function NotificationMessageBody({ message }) {
  const parsed = useMemo(() => parseNotificationMessage(message), [message]);
  const text = String(message ?? "").trim();

  if (!text) {
    return (
      <p className="notif-detail__message notif-detail__message--empty">
        No message body.
      </p>
    );
  }

  if (!parsed?.hasStructure) {
    return <p className="notif-detail__message">{text}</p>;
  }

  return (
    <div className="notif-msg">
      {parsed.greeting ? (
        <p className="notif-msg__line">{parsed.greeting},</p>
      ) : null}

      {parsed.paragraphs.map((line) => (
        <p key={line} className="notif-msg__line">
          {line}
        </p>
      ))}

      {parsed.details.length > 0 ? (
        <ul className="notif-msg__details">
          {parsed.details.map(({ label, value }) => (
            <li key={`${label}-${value}`}>
              <span>{label}</span> {value}
            </li>
          ))}
        </ul>
      ) : null}

      {parsed.nextStep ? (
        <p className="notif-msg__line">{parsed.nextStep}</p>
      ) : null}

      {parsed.portalUrl ? (
        <p className="notif-msg__line">
          <a
            className="notif-msg__link"
            href={parsed.portalUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open portal
          </a>
        </p>
      ) : null}

      <p className="notif-msg__signoff">
        Regards,
        <br />
        {parsed.closing}
      </p>
    </div>
  );
}
